import API from '../services/api';

const api = new API();
const URL_AGENCY_SIGNUP_SUBMIT = '/signup/submit/agency';
const URL_RESEND_EMAIL = '/signup/resend_email';
const URL_CHECK_AGENCY_NAME = '/api/signup/agency/check-name';

export default class AgencySignupService {
    submitAgencySignupForm(data) {
        return api.getJson(URL_AGENCY_SIGNUP_SUBMIT, {
            method: 'POST',
            legacyStatus: true,
            body: {
                full_name: data.fullName,
                email: data.email,
                password: data.password,
                company_name: data.companyName,
                active_advertiser_clients: data.activeAdvertiserClients,
                timezone_name: data.timezoneName,
                currency_code: data.currencyCode,
                recaptcha_token: data.recaptchaToken,
            },
        });
    }

    resendEmail(data) {
        return api.getJson(URL_RESEND_EMAIL, {
            method: 'POST',
            legacyStatus: true,
            body: {
                email: data.email,
            },
            fixErr: true,
        });
    }

    checkAgencyName(agencyName, email) {
        return api.getJson(URL_CHECK_AGENCY_NAME, {
            method: 'GET',
            params: { agency_name: agencyName, email },
        });
    }
}
